import { render, staticRenderFns } from "./AuctionDeleteModal.vue?vue&type=template&id=b00d52ea"
import script from "./AuctionDeleteModal.vue?vue&type=script&lang=js"
export * from "./AuctionDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports